// Chữ hiển thị + phép tính thuần của hệ giới thiệu. Tách khỏi component để
// test được mà không phải dựng React.
import type { AffiliateGroup } from "./api";

export const GROUP_LABEL: Record<AffiliateGroup, string> = {
  staff: "Nhân viên",
  partner: "Đối tác",
  koc_kol: "KOC/KOL",
  customer: "Khách hàng",
};

/** Link người giới thiệu đem đi rải: trang đặt lịch kèm mã (spec §4.1). */
export function shareLink(origin: string, code: string): string {
  return `${origin}/booking?ma=${encodeURIComponent(code)}`;
}
